module.exports = __webpack_public_path__ + "officialStatic/img/index-product-sj.2d2cad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index-product-sj.png
// module id = pc53
// module chunks = 0